import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PayBankDetailUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult() {
        return await this.Repo.getPayBankDetails();
    }
}
export default PayBankDetailUseCase;
